var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout-main",class:{ 'p-t-100': _vm.$store.state.setPdTop }},[_c('router-view',{attrs:{"name":"AppTopBar"}}),_c('router-view',{key:_vm.$router.currentRoute.fullPath}),_c('router-view',{attrs:{"name":"AppBtmBar"}}),_c('RepairDilog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }